import V3Factory from "../helpers/V3";
export default function configureV3() {
    return V3Factory('https://book.txj.co.jp/v4', 'kita_mana', 'OzucityJP');
}
